// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "reactPlayerPreview" + "." + "f48ee7ce514983ab12c0" + ".js";
};